const en = {
  downloadButtonLabel: 'Download PDF',
};

export default en;
